import React, { useRef } from "react";
import styled from "styled-components";
import "./Layout.css";
import Title from "./barraLateral/components/Title";
import { Toast } from "primereact/toast";
import UserInfo from "./barraLateral/components/UserInfo";
import BarraLateral from "./barraLateral";
import { useGlobal } from "App/Hooks/global/GlobalContext";
import { Outlet } from "react-router-dom";

//theme
import "primereact/resources/themes/lara-light-indigo/theme.css";

//core
import "primereact/resources/primereact.min.css";

//icons
import "primeicons/primeicons.css";

const Main = styled.div`
  transition-property: opacity;
  transition-duration: 1s;
  opacity: ${(props) => (props.active ? 0.4 : 1)};
  height: 100vh;
  overflow-y: auto;
`;
const Contenedor = styled.section`
  height: 100vh;
`;

export default function Layout() {
  const growl = useRef(null);
  const { barraActiva, setBarraActiva } = useGlobal();
  const switchMenu = () => setBarraActiva(!barraActiva);

  return (
    <Contenedor>
      <div className={barraActiva ? "Navbar nav-active" : "Navbar"}>
        <Title />
        <UserInfo />
        <BarraLateral onSwitch={switchMenu} />
      </div>
      <Main
        active={barraActiva}
        onClick={barraActiva ? () => setBarraActiva(false) : null}
      >
        <Outlet />
      </Main>
      <Toast ref={growl} />
    </Contenedor>
  );
}
